import React, { SVGAttributes } from 'react'

const SvgPencil = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 10 10" {...props}>
    <path d="M8.19.19a.6.6 0 0 0-.87 0L0 7.5V10h2.5l7.31-7.31a.6.6 0 0 0 0-.87z" fill="#313537" fillRule="evenodd" />
  </svg>
)

export default SvgPencil
